import React, { useCallback, useRef, useState } from 'react';
import { useSelector } from 'umi';
import Filter from '@/pages/dashboard/components/NewFilter';
import { FORM_MAP } from '@/pages/dashboard/pages/overview/_config/constant';
import { setBtnPointLog } from "@/pages/dashboard/utils/utils";
import { formatDateFromFilterValue } from "@/pages/dashboard/utils/formatDate";
import { getDateDefault } from '@/pages/dashboard/utils/dateUtils';

// 筛选器路径
const FILTER_PATH = 'overview/daily';

/**
 *
 * @param props
 * @param props:filterConfirm 筛选器确认函数
 * @param props:filterReset 筛选器重置函数
 * @param props:filterInit 初始化函数，会向外部传递初始化后的筛选器值
 * @returns
 */

// daily筛选器继承逻辑
const NightingaleDataRangeFilter = (props: any) => {
  const { filterConfirm, filterReset, filterInit, buttonLogConfig, path = FILTER_PATH, openSticky = false, children, timeZone = 0 } = props;
  // const timeDiff = useRef<boolean>(false);
  const filterValueRef = useRef<any>(null); // 筛选器值，此处不用state，更新formValue同样会触发组件更新
  const seasonInfo = useSelector((state: any) => 
    // 初始可能为undefied,在此加兜底
    state?.dashboardSetting?.gameConfig?.season_info || { date: [], week: [], month: [] }
  );
  // 设置inputList,和后端核对后，此次筛选器的展示都是由后端控制，配置为时间，地区，平台和语言四个筛选器
  const [inputList] = useState([
    {
      type: 'rangeDaily',
      key: 'rangeTime',
      default: getDateDefault({timeType: 'day', timeZone, startNum: 14, endNum: 1}),
      extraShortcut: seasonInfo
    },
  ]);

  // 私有化处理，抹平新旧筛选器的差距
  const onInit = useCallback((value, _inputList, _isLock, urlIsEmpty) => {
    filterValueRef.current = value;
    filterInit({
      ...(formatDateFromFilterValue(value, 'Day') || {}),
      [FORM_MAP.RANGE_TIME_DIFF]: !urlIsEmpty,
      timeType: "Day",
    });
  }, [filterInit]);

  const onConfirm = useCallback((value) => {
    filterValueRef.current = value;
    const obj: any = {
      ...(formatDateFromFilterValue(value, 'Day') || {}),
      [FORM_MAP.RANGE_TIME_DIFF]: false,
      timeType: "Day"
    };
    filterConfirm(obj);
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, formatDateFromFilterValue(value, 'Day'));
  }, [filterConfirm]);

  const onReset = useCallback((value) => {
    filterValueRef.current = value;
    const obj = {
      ...(formatDateFromFilterValue(value, 'Day') || {}),
      [FORM_MAP.RANGE_TIME_DIFF]: true,
      timeType: "Day"
    };
    filterReset(obj);
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, formatDateFromFilterValue(value, 'Day'), true);
  }, [filterReset]);

  return <Filter
    openSticky={openSticky}
    path={path}
    latestDateType={''}
    value={filterValueRef.current}
    inputList={inputList}
    onInit={onInit}
    onConfirm={onConfirm}
    onReset={onReset}
  >
    {children}
  </Filter>;
};

export default NightingaleDataRangeFilter;
